import request from "../config"
import api from './api'

// function urlToParams(obj) {
//   return Object.keys(obj).map(function(key) {
//     return encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]);
//   }).join("&");
// }

export default class NetService {
  /**
   * @description 获取用户临停费用订单信息
   * @param data 
   */
  static CreateOrder(data) {
    return request[api.CreateOrder.method](api.CreateOrder.uri, data)
  }
  
  /**
   * @description 发起支付
   * @param data 
   */
  static ConfirmOrder(data) {
    return request[api.ConfirmOrder.method](api.ConfirmOrder.uri, data)
  }

  /**
   * @description 变更用户临时停车费记录状态
   * @param data 
   */
  static NotifyOrder(data) {
    return request[api.NotifyOrder.method](api.NotifyOrder.uri, data)
  }

  /**
   * @description 支付
   * @param data 
   */
  static PayOrder(data) {
    return request[api.PayOrder.method](api.PayOrder.uri, data)
  }

  /**
   * @description 访客二维码
   * @param id
   */
    static Visitor(id) {
      return request[api.Visitor.method](api.Visitor.uri + id)
  }
  /**
   * @description 访客二维码
   * @param data
   */
  static Register(data) {
      return request[api.Register.method](api.Register.uri, data)
  }
  /**
   * @description 邀请函
   * @param data
   */
   static Invite(data) {
    return request[api.Invite.method](api.Invite.uri, data)
  }
  /**
   * @description 人员登记
   * @param data
   */
  static Registration(data) {
    return request[api.Registration.method](api.Registration.uri, data)
  }
  /**
   * @description 人员登记
   * @param data
   */
  static ImageUpload(data) {
    return request[api.ImageUpload.method](api.ImageUpload.uri, data)
  }
  /**
   * @description 广告banner
   * @param data
   */
  static GetBanners(data) {
    return request[api.GetBanners.method](api.GetBanners.uri, data)
  }
  /**
   * @description  banner点击统计
   * @param data
   */
  static AddClickRate(data) {
    return request[api.AddClickRate.method](api.AddClickRate.uri + data, data)
  }
  /**
   * @description 人员登记
   * @param data
   */
  static Carsarchiv(data) {
    return request[api.Carsarchiv.method](api.Carsarchiv.uri, data)
  }
  /**
   * @description 开门
   * @param data
   */
  static OpenDoor(data) {
    return request[api.OpenDoor.method](api.OpenDoor.uri + data, data)
  }
  /**
   * @description 查询开门状态
   * @param data
   */
  static CheckDoorStatus(data) {
    return request[api.CheckDoorStatus.method](api.CheckDoorStatus.uri + data, data)
  }
  /**
   * @description 查询开门状态
   * @param sn
   */
  static OpenStateBySn(sn) {
    return request[api.CheckDoorStatus.method](api.CheckDoorStatus.uri + sn)
  }
  /**
 * @description 查询月卡信息
 * @param sn
 */
    static GetCardInformation(data) {
    return request[api.queryMonthlyCardInformation.method](api.queryMonthlyCardInformation.uri, data)
  }
  /**
 * @description 月卡支付缓存订单
 * @param sn
 */
   static deferredPaymentOfMonthlyCard(data) {
    return request[api.deferredPaymentOfMonthlyCard.method](api.deferredPaymentOfMonthlyCard.uri, data)
  }
  /**
 * @description 月卡支付
 * @param sn
 */
   static cacheOrders(data) {
    return request[api.cacheOrders.method](api.cacheOrders.uri, data)
  }
  // 应收APP缴费单
  static accountsReceivableAppPaymentForm(data) {
    return request[api.accountsReceivableAppPaymentForm.method](api.accountsReceivableAppPaymentForm.uri, data)
  }
  // 获取订单号
  static queryOrderId(data) {
    return request[api.queryOrderId.method](api.queryOrderId.uri, data)
  }
  // 支付
  static lakalAppPay(data) {
    return request[api.lakalAppPay.method](api.lakalAppPay.uri, data)
  }
  // 查询支付状态
  static getpayStatus(data) {
    return request[api.getpayStatus.method](api.getpayStatus.uri, data)
  }
  // 收银台支付
  static QRCodePay(data) {
    return request[api.QRCodePay.method](api.QRCodePay.uri, data)
  }
  // 获取问卷
  static getQuestionnaire(data) {
    return request[api.getQuestionnaire.method](api.getQuestionnaire.uri + data)
  }
  // 保存问卷
  static saveQuestionnaire(data) {
    return request[api.saveQuestionnaire.method](api.saveQuestionnaire.uri, data)
  }
}